import React from 'react';

interface FeatureHeadingProps {
    title: string;
    description: string;
}

const FeatureHeading: React.FC<FeatureHeadingProps> = ({ title, description }) => {
    return (
        <React.Fragment>
            <div className='pb-4 sm:pb-8 bg-white'>
                <div className='max-w-7xl mx-auto'>
                    <div className='lg:text-center'>
                        <h2 className='text-base text-pink-600 font-semibold tracking-wide uppercase'>UNS Tools</h2>
                        <p className='mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl'>{title}</p>
                        <p className='mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto'>{description}</p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default FeatureHeading;
